module.exports = __webpack_public_path__ + "static/img/rz-15.6d7be26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rz-15.png
// module id = 0OAB
// module chunks = 0